import type { Permission } from '@/lib/rbac/permissions';
import { COLLECTIONS } from './collections';
import { LEAD_TYPES } from './leadTypes';

/**
 * Information architecture (spec §7). Each node is gated by the permission that reveals it
 * (hide if unreadable). The sidebar renders from this + RBAC (plan §3.3 / §4.3).
 */
export interface NavLeaf {
  type: 'leaf';
  navKey: string; // i18n key under nav.*
  to: string;
  permission: Permission;
}
export interface NavGroup {
  type: 'group';
  navKey: string;
  children: NavLeaf[];
}
export type NavNode = NavGroup | NavLeaf;

export const NAV: NavNode[] = [
  { type: 'leaf', navKey: 'dashboard', to: '/', permission: 'content:read' },
  {
    type: 'group',
    navKey: 'content',
    children: [
      // Pages (the page-copy documents, D1) + the two V1 collections. Product
      // families and the eight legacy collections are dropped (D4).
      { type: 'leaf', navKey: 'pages', to: '/pages', permission: 'content:read' },
      ...COLLECTIONS.map(
        (c): NavLeaf => ({
          type: 'leaf',
          navKey: c.navKey,
          to: `/content/${c.key}`,
          permission: 'content:read',
        }),
      ),
    ],
  },
  { type: 'leaf', navKey: 'media', to: '/media', permission: 'content:read' },
  {
    type: 'group',
    navKey: 'leads',
    children: LEAD_TYPES.map(
      (t): NavLeaf => ({
        type: 'leaf',
        navKey: t.navKey,
        to: `/leads/${t.key}`,
        permission: 'leads:read',
      }),
    ),
  },
  { type: 'leaf', navKey: 'audit', to: '/audit', permission: 'audit:read' },
  {
    type: 'group',
    navKey: 'administration',
    children: [
      { type: 'leaf', navKey: 'users', to: '/users', permission: 'users:manage' },
      { type: 'leaf', navKey: 'settings', to: '/settings', permission: 'settings:manage' },
    ],
  },
];
